export default __webpack_public_path__ + "static/media/Avatar-21-noback.f0dc3500.png";